import Geocode, { GeocodeService, GeocodeFeature, BoundingBox } from '@mapbox/mapbox-sdk/services/geocoding';
import Directions, {
  DirectionsService,
  DirectionsProfile,
  DirectionsRequestWaypoint
} from '@mapbox/mapbox-sdk/services/directions';
import { SdkConfig } from '@mapbox/mapbox-sdk/lib/classes/mapi-client';
import { projectDefaultBoundingBox } from '@/services/utils.service';

const MapiClient = require('@mapbox/mapbox-sdk');

const config: SdkConfig = { accessToken: process.env.VUE_APP_MAPBOX };
const client = new MapiClient(config);

const geocode: GeocodeService = Geocode(client);
const directions: DirectionsService = Directions(client);

const GetPlaces = (query: string): Promise<GeocodeFeature[]> => {
  // types is deprecated
  const boundingBox: BoundingBox = (projectDefaultBoundingBox() as unknown) as BoundingBox;

  return geocode
    .forwardGeocode({
      mode: 'mapbox.places',
      query: query,
      limit: 5,
      bbox: boundingBox
    })
    .send()
    .then<GeocodeFeature[]>(
      ({ body: { features } }) => features,
      ({ body }) => Promise.reject(body)
    );
};

const GetDirections = (waypoints: DirectionsRequestWaypoint[]) => {
  return directions
    .getDirections({
      profile: 'driving',
      waypoints,
      geometries: 'geojson'
    })
    .send()
    .then(response => {
      return response.body;
    });
};

export default {
  GetPlaces,
  GetDirections
};
